import React from "react";
import { createPortal } from "react-dom";

interface RiskScoreDetailsModalProps {
  open: boolean;
  details: any | null;
  onClose: () => void;
}

const RiskScoreDetailsModal: React.FC<RiskScoreDetailsModalProps> = ({
  open,
  details,
  onClose,
}) => {
  if (!open) return null;

  const modal = (
    <div
      className="modal-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 3000,
      }}
    >
      <div className="risk-modal-content">
        <button
          className="risk-modal-close-btn"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>
        <h3>Risk Score Details</h3>
        <pre className="risk-score-details">
          {JSON.stringify(details, null, 2)}
        </pre>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
};

export default RiskScoreDetailsModal;
